export default {
  mainChamber: 'Przegląd pieca',
  chamber: 'Komora {subSystemId}',
};
